import { render, staticRenderFns } from "./Alerts-list.vue?vue&type=template&id=288bcbde&scoped=true"
import script from "./Alerts-list.vue?vue&type=script&lang=js"
export * from "./Alerts-list.vue?vue&type=script&lang=js"
import style0 from "./Alerts-list.vue?vue&type=style&index=0&id=288bcbde&prod&scoped=true&lang=css"
import style1 from "./Alerts-list.vue?vue&type=style&index=1&id=288bcbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bcbde",
  null
  
)

export default component.exports